import React from 'react'
import { SimilarProductsComponent } from '#src/generated/graphql'
import { FullBlockLoader, CircleLoader } from '@deal/components'
import SellableCardCarousel from '../SellableCardCarousel'

interface Props {
  sellableId: string
  ssr?: boolean
}

const SimilarProducts: React.SFC<Props> = ({ sellableId, ssr = true }) => {
  return (
    <SimilarProductsComponent variables={{ sellableId }} ssr={ssr}>
      {({ loading, data }) => {
        if (loading) {
          return <FullBlockLoader loader={CircleLoader} />
        }

        if (data && data.similarSellables && data.similarSellables.sellables) {
          const { sellables } = data.similarSellables

          // Does this look weird with just one?
          if (sellables.length === 0) {
            return null
          }

          return <SellableCardCarousel sellables={sellables} />
        }

        return null
      }}
    </SimilarProductsComponent>
  )
}

export default SimilarProducts
